import React, { useState, useEffect, useContext, Suspense, } from "react";
import { connect } from "react-redux";
import ServerMasterTable from "../../components/common/ServerMasterTable";
import { Form, Formik } from "formik";
import { Button, FormGroup, Row } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import {
  FormikDatePicker,
  FormikReactSelect,
} from "../../containers/form-validations/FormikFields";
import FormLoader from "../../components/loader/FormLoader";
import { getVoucherSale, generateInvoice, deleteDeliveryNote } from "../../redux/admin/Report/action";
import { getDspUser1 } from "../../redux/admin/SimInvoice/action";
import { clearDeliveryNotesPreview, generateDeliveryNotes } from "../../redux/admin/CardInvoice/action";
import { apiDate, getDate1, getPriceFormatter } from "../../constants/defaultValues";
import IntlMessages from "../../utils/IntlMessages";
import { LayoutContext } from "../../layouts/UserLayout";
import { getLocalTime1 } from "../../constants/defaultValues";
import { hasPermission } from "../../utils/UserDetails";
import ConfirmModalDeliveryNotes from "../../components/notifcationmodal/ConfirmModalDeliveryNotes";
import { showModal } from "../../redux/modal/actions";


const DeliveryNotesReport = ({
  getDspUser1,
  getVoucherSale,
  customerslist,
  voucherSaleData,
  onDeliveryNote,
  generateDeliveryNotes,
  deliveryNotesData,
  generateInvoice,
  menuId,
  clearDeliveryNotesPreview,
  showModal,
  deleteDeliveryNote
}) => {

  const { setPageTitle } = useContext(LayoutContext);

  const modalData = {
    isSuccess: 2,
    header: "Are you sure to generate invoice ?",
  };

  const options1 = [
    { value: "", label: "All" },
    { value: "sim", label: "Sim" },
    { value: "voucher", label: "Voucher" },
  ];

  const [currentDate] = useState(apiDate(new Date()));
  const [hswtCheckedMap, setHswtCheckedMap] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoadingPreview, setIsLoadingPreview] = useState(false);
  const [invoiceNumberMap, setInvoiceNumberMap] = useState({});

  const initialData = {
    fromDate: currentDate ? new Date(currentDate) : new Date(),
    toDate: currentDate ? new Date(currentDate) : new Date(),
    userid: { value: null, label: "All" },
    type: { value: null, label: "All" },
  };
  const [initialValues, setIntialValues] = useState(initialData);
  const [filterShow, setFilterShow] = useState("Today");
  const [manageDetailsParam, setManageDetailsParam] = useState({
    limit: 50,
    offset: 0,
    searchTerm: "",
    orderBy: "createdat",
    format: "DESC",
    fromDate: currentDate ? currentDate : new Date(),
    toDate: currentDate ? currentDate : new Date(),
    userid: "",
    type: "",
  });
  const [userData, setUserData] = useState([]);
  const [show, setShow] = useState(false);
  const [notificationData, setNotificationData] = useState(modalData);
  const [invoiceError, setInvoiceError] = useState("");
  const [isPreviewRequested, setIsPreviewRequested] = useState(false);
  const [showOrderInput, setShowOrderInput] = useState(false);
  const [orderNumber, setOrderNumber] = useState("");

 console.log(voucherSaleData)

  useEffect(() => {
    setPageTitle(<IntlMessages id={menuId} />);
    return () => setPageTitle("");
  }, [setPageTitle]);

  useEffect(() => {
    getDspUser1();
  }, [getDspUser1]);

  useEffect(() => {
    getVoucherSale(manageDetailsParam);
  }, [manageDetailsParam]);

  useEffect(() => {
    setSelectedRows([]);
  }, [voucherSaleData]);

  useEffect(() => {
    if (customerslist?.length) {
      const data1 = [
        {
          value: null,
          label: "All",
        },
        ...customerslist.map((item, index) => ({
          key: index,
          value: item.user_id,
          label:
            item.relationship_no +
            " - " +
            item.username +
            " - " +
            item.user_type_name +
            (customerslist
              .filter((item1) => item1.relationship_id === item.parent_id)
              .map((item2) => ` -- (${item2.username})`)
              .join(", ") || ""),
          retailerswap: item.retailerswap,
        })),
      ];

      setUserData(data1);
    }
  }, [customerslist]);

useEffect(() => {
  if (
    isPreviewRequested &&
    deliveryNotesData &&
    deliveryNotesData instanceof Blob
  ) {
    const url = URL.createObjectURL(deliveryNotesData);
    window.open(url, "_blank");

    setIsPreviewRequested(false);
    setIsLoadingPreview(false);
  }
}, [deliveryNotesData, isPreviewRequested]);


  const toggleHswtForInvoice = (deliverynotesid) => {
    setHswtCheckedMap((prev) => ({ ...prev, [deliverynotesid]: !prev[deliverynotesid] }));
  };

  const handlePreview = (deliverynotesid) => {
    //const vat = hswtCheckedMap[deliverynotesid] ? 1 : 0;

    setIsLoadingPreview(true);
  setIsPreviewRequested(true);
  
   clearDeliveryNotesPreview();

    let params = {
      deliverynoteid: deliverynotesid,
      vat: 1,
      isPdf: 1,
      isPreview: true
    };

    generateDeliveryNotes(params);
  };

  const handleDeliveryNote = (deliverynotesid) => {
    //const vat = hswtCheckedMap[deliverynotesid] ? 1 : 0;
    let params = {
      deliverynoteid: deliverynotesid,
      vat: 1,
      isPdf: 1
    };
    generateDeliveryNotes(params);
  };

  const toggleModal = () => {
    setShow(!show);
  };

const deleteData = () => {
  setShow(false);

  let params = {
    ...notificationData.data,
  };

  if (showOrderInput && orderNumber) {
    params.ordernumber = orderNumber;
  }

  generateInvoice(params);
};


  const handleSelectRow = (id) => {
    setInvoiceError("")      
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const handleSelectAll = () => {
    const currentPageIds =
      voucherSaleData?.data?.map(item => item.deliverynoteid) || [];

    if (!currentPageIds.length) return;

    const allSelected = currentPageIds.every(id =>
      selectedRows.includes(id)
    );

    if (allSelected) {
      setSelectedRows(prev =>
        prev.filter(id => !currentPageIds.includes(id))
      );
    } else {
      setSelectedRows(prev =>
        Array.from(new Set([...prev, ...currentPageIds]))
      );
    }
  };

const handleBulkGenerate = () => {
  setInvoiceError("");

  const selectedData =
    voucherSaleData?.data?.filter(item =>
      selectedRows.includes(item.deliverynoteid)
    ) || [];

  const uniqueUserIds = [
    ...new Set(selectedData.map(item => item.relationshipno)),
  ];

  if (uniqueUserIds.length > 1) {
    setInvoiceError("Please select delivery notes from the same user only");
    return;
  }

  const uniqueTypes = [
    ...new Set(selectedData.map(item => item.type)),
  ];

  if (uniqueTypes.length > 1) {
    setInvoiceError("Please select either SIM or Voucher delivery notes only");
    return;
  }

  const params = {
    deliverynoteid: selectedRows,
  };

  const selectedType = uniqueTypes[0];

  if (selectedType === 0) {
    generateInvoice(params);
    return;
  }

  setNotificationData({
    header: "Generate Invoice",
    data: params,
  });

  setShowOrderInput(false);
  setOrderNumber("");
  setShow(true);
};



  // Helper function to check if selected rows have different users
  const hasMultipleUsers = () => {
    if (selectedRows.length === 0) return false;
    
    const selectedData = voucherSaleData?.data?.filter(item => 
      selectedRows.includes(item.deliverynoteid)
    ) || [];
    
    const uniqueUserIds = [...new Set(selectedData.map(item => item.userid))];
    return uniqueUserIds.length > 1;
  };

  const handleInvoice = (data) => {
    console.log(data)
    setNotificationData({
      ...notificationData,
      ...{
        header: "Are you sure to generate invoice?",
        isLoading: 0,
        data: {
          invoiceid: data,
          isPdf: 1,
        },
      },
    });
    setShow(true);
  };

  const handleInvoicePreview = (invoiceId) => {
    const params = {
      invoiceid: invoiceId,
      isPdf: 1,
      isPreview: true
    };
    setIsLoadingPreview(true);
    generateInvoice(params);
  };

  const handleInvoiceNumberChange = (invoiceId, value) => {
    setInvoiceNumberMap((prev) => ({
      ...prev,
      [invoiceId]: value,
    }));
  };

  const handleInvoiceNumberBlur = (invoiceId, value) => {
    if (!value) return;

    updateInvoiceNumber({
      invoiceid: invoiceId,
      invoicenumber: value,
    });
  };

  const updateInvoiceNumber = (data) => {
    console.log("Updated Invoice Number:", data);
  };

const cols = React.useMemo(() => {
  const columns = [
    {
      Header: <IntlMessages id="serial-no" />,
      accessor: "simvoucherrequestid",
      cellClass: "text-center",
      Cell: (props) =>
        parseInt(props.row.id) + 1 + parseInt(manageDetailsParam.offset),
      sortType: "basic",
    },
    {
      Header: <IntlMessages id="deliverynotesdate" />,
      accessor: "invoicedate",
      Cell: (props) => getDate1(props.value),
      cellClass: "text-center",
    },
    {
      Header: <IntlMessages id="deliverynotesnumber" />,
      accessor: "deliverynotenumber",
      cellClass: "text-center",
    },
    {
      Header: <IntlMessages id="user-list.companyname" />,
      accessor: "companyname",
      Cell: (props) =>
        `${props.row.original.companyname ?? ""}-${props.row.original.relationshipno ?? ""}`,
      cellClass: "text-center",
    },
    {
      Header: <IntlMessages id="customer-name" />,
      accessor: "username",
      cellClass: "text-center",
    },
    {
      Header: <IntlMessages id="invoiceamount" />,
      accessor: "invoiceamount",
      Cell: (props) =>
        props.value ? getPriceFormatter(props.value) : "-",
      cellClass: "text-center",
    },    {
      Header: 'Invoice Type',
      accessor: "type",
      Cell: (props) =>
        props.value == 0 ? "SIM" : "VOUCHER",
      cellClass: "text-center",
    },
    {
      Header: "Created at",
      accessor: "createdat",
      Cell: (props) => getLocalTime1(props.value),
      cellClass: "text-center",
      sortType: "basic",
    },
  ];

  /* ---------------- canWrite ---------------- */
  if (hasPermission(menuId, "canWrite")) {
    columns.unshift({
      Header: <div className="text-center">Select</div>,
      accessor: "select_row",
      disableSortBy: true,
      cellClass: "text-center",
      Cell: (props) => {
        const id = props.row.original.deliverynoteid;
        return (
          <input
            type="checkbox"
            checked={selectedRows.includes(id)}
            onChange={() => handleSelectRow(id)}
            style={{ cursor: "pointer" }}
          />
        );
      },
    });
  }

  /* ---------------- canPrint ---------------- */
  if (hasPermission(menuId, "canPrint")) {
    columns.push(
      {
        Header: "Delivery Notes Preview",
        accessor: "preview",
        cellClass: "text-center",
        disableSortBy: true,
        Cell: (props) => {
          const id = props.row.original.deliverynoteid;
          return (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handlePreview(id);
              }}
              style={{
                color: "#007bff",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              View
            </a>
          );
        },
      },

    );
  }

    if (hasPermission(menuId, "canPrint") ||hasPermission(menuId, "canDelete")) {
    columns.push({
      Header: <IntlMessages id="user-list.action" />,
      accessor: "action",
      cellClass: "text-center",
      Cell: (props) => {
        const id = props.row.original.deliverynoteid;
       return (
        <div className="d-flex actions justify-content-center">
          {hasPermission(menuId, "canPrint") && (
            <i
              className="simple-icon-cloud-download p-1 cursor-pointer"
              onClick={() => handleDeliveryNote(id)}
            />
          )}

          {hasPermission(menuId, "canDelete") && (
            <i
              className="simple-icon-trash p-1 cursor-pointer"
              onClick={() => handleDelete({deliverynoteid:id})}
            />
          )}
        </div>
      )},
    });
  }

  return columns;
}, [
  menuId,
  manageDetailsParam.offset,
  selectedRows,
  hswtCheckedMap,
  voucherSaleData,
]);


  const handleFilterChange = (filter) => {
    setFilterShow(filter);
    const today = new Date();

    if (filter === "Today") {
      setIntialValues((prev) => ({
        ...prev,
        fromDate: today,
        toDate: today,
      }));
    }

    if (filter === "ThisMonth") {
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      setIntialValues((prev) => ({
        ...prev,
        fromDate: firstDay,
        toDate: lastDay,
      }));
    }

    if (filter === "All") {
      setIntialValues((prev) => ({
        ...prev,
        fromDate: "",
        toDate: "",
      }));
    }
  };

    const handleDelete= (data) => {
      showModal({
        title: "Are you sure you want to Delete?",
        message: "",
        yesLabel: "Yes",
        noLabel: "No",
        yesType: "api",
        onYes: () => deleteDeliveryNote(data),
        onNo: () => console.log("Stayed"),
      })
    
  };

  return (
    <>
      <div className="p-3">
        <h3></h3>

        <div className="card shadow-sm mt-3">
          <div className="card-header border-0 pb-0">
            <Row className="align-items-center">
              <Colxx xs="12" md="12" className="mb-2 mb-md-0">
                <div className="d-flex flex-wrap align-items-center">
                  <Button
                    type="button"
                    className={`me-2 mb-2 btn-sm ${filterShow === "Today" ? "btn-primary" : "btn-outline-primary"
                      }`}
                    onClick={() => handleFilterChange("Today")}
                  >
                    <IntlMessages id="today" />
                  </Button>

                  <Button
                    type="button"
                    className={`me-2 mb-2 btn-sm ${filterShow === "ThisMonth" ? "btn-primary" : "btn-outline-primary"
                      }`}
                    onClick={() => handleFilterChange("ThisMonth")}
                  >
                    <IntlMessages id="thismonth" />
                  </Button>

                  <Button
                    type="button"
                    className={`me-2 mb-2 btn-sm ${filterShow === "All" ? "btn-primary" : "btn-outline-primary"
                      }`}
                    onClick={() => handleFilterChange("All")}
                  >
                    <IntlMessages id="all" />
                  </Button>
                </div>
              </Colxx>
            </Row>
          </div>

          <div className="card-body pt-2">
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              onSubmit={(formData, { setSubmitting }) => {
                setIntialValues(formData);
                const params = {
                  userid: formData?.userid?.value ?? null,
                  type: formData?.type?.value,
                  relationshipno: formData?.relationshipno?.value,
                  limit: 50,
                  offset: 0,
                  searchTerm: "",
                  orderBy: "createdat",
                  format: "DESC",
                  fromDate: formData.fromDate ? apiDate(formData.fromDate) : null,
                  toDate: formData.toDate ? apiDate(formData.toDate) : null,
                };

                setManageDetailsParam(params);
                setTimeout(() => setSubmitting(false), 600);
              }}
            >
              {({
                setFieldValue,
                setFieldTouched,
                values,
                errors,
                touched,
                isSubmitting,
              }) => (
                <Form className="av-tooltip tooltip-label-bottom">
                  <Row className="align-items-start mb-0">
                    <Colxx md="3">
                      <FormGroup className="form-group has-float-label mb-3">
                        <label>
                          <IntlMessages id="from" />
                        </label>
                        <FormikDatePicker
                          name="fromDate"
                          value={values.fromDate}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          className="datepicker-styles"
                          placeholder=" "
                        />
                        <div className="text-danger small mt-1">
                          {errors.fromDate && touched.fromDate ? "Date Required" : null}
                        </div>
                      </FormGroup>
                    </Colxx>

                    <Colxx md="3">
                      <FormGroup className="form-group has-float-label mb-3">
                        <label>
                          <IntlMessages id="to" />
                        </label>
                        <FormikDatePicker
                          name="toDate"
                          value={values.toDate}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          className="datepicker-styles"
                          placeholder=" "
                        />
                        <div className="text-danger small mt-1">
                          {errors.toDate && touched.toDate ? "Date Required" : null}
                        </div>
                      </FormGroup>
                    </Colxx>

                    <Colxx md="3">
                      <FormGroup className="form-group has-float-label mb-3">
                        <label>
                          <IntlMessages id="customer-name" />
                        </label>
                        <FormikReactSelect
                          name="userid"
                          id="userid"
                          value={values.userid}
                          options={userData}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          placeholder=" "
                        />
                        <div className="text-danger small mt-1">
                          {errors.userid && touched.userid ? errors.userid : null}
                        </div>
                      </FormGroup>
                    </Colxx>

                    <Colxx md="3">
                      <FormGroup className="form-group has-float-label mb-3">
                        <label>
                          <IntlMessages id="type" />
                        </label>
                        <FormikReactSelect
                          name="type"
                          id="type"
                          value={values.type}
                          options={options1}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          placeholder=" "
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>

                  <Row className="mb-3">
                    <Colxx md="12" className="text-end">
                      <Button type="submit" className="btn-sm me-2" color="primary" disabled={isSubmitting}>
                        {isSubmitting ? <FormLoader /> : <IntlMessages id="view" />}
                      </Button>

                      <Button type="button" className="btn-sm" color="secondary">
                        <IntlMessages id="cancel" />
                      </Button>
                    </Colxx>
                  </Row>
                </Form>
              )}
            </Formik>

            {/* Select All Checkbox and Generate Invoice Button */}
                                          {hasPermission(menuId, 'canWrite') && (

            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="selectAllCheckbox"
                    checked={
                      voucherSaleData?.data?.length > 0 &&
                      voucherSaleData.data.every(row =>
                        selectedRows.includes(row.deliverynoteid)
                      )
                    }
                    onChange={handleSelectAll}
                    style={{ cursor: "pointer", width: "18px", height: "18px" }}
                  />
                  <label 
                    htmlFor="selectAllCheckbox" 
                    className="mb-0 ms-2" 
                    style={{ cursor: "pointer", fontWeight: "500" }}
                  >
                    Select All
                  </label>
                </div>
                
                <Button 
                  color="success" 
                  size="sm" 
                  onClick={handleBulkGenerate}
                  disabled={selectedRows.length === 0}
                >
                  Generate Invoice
                </Button>
              </div>
              <div className="d-flex justify-content-end ">
              {invoiceError && (
                <div className="text-danger small mt-1 ms-3">
                  {invoiceError}
                </div>
              )}
            </div>
            </div>
                                          )}

            <div className="mt-2">
              <ServerMasterTable
                columns={cols}
                batchParam={manageDetailsParam}
                setBatchParam={setManageDetailsParam}
                data={voucherSaleData?.data?.length ? voucherSaleData?.data : []}
              />
            </div>
          </div>
        </div>
      </div>
<Suspense>
  <ConfirmModalDeliveryNotes
    modalOpen={show}
    toggleModal={toggleModal}
    modalData={{
      ...notificationData,
      showOrderInput,
      setShowOrderInput,
      orderNumber,
      setOrderNumber,
    }}
    performModalFunction={deleteData}
  />
</Suspense>

    </>
  );
};

const mapStateToProps = (state) => ({
  customerslist: state.sim.adminuser,
  voucherSaleData: state.report.voucherSaleData,
  deliveryNotesData: state.cardData.deliveryNotesData,
});

export default connect(mapStateToProps, {
  getDspUser1,
  getVoucherSale,
  generateDeliveryNotes,
  generateInvoice,
  clearDeliveryNotesPreview,
  showModal,
  deleteDeliveryNote
})(DeliveryNotesReport);